import React from 'react';
import PropTypes from 'prop-types';

const Image = ({ image, ...rest }) => {
  if (!image || !image.fields || !image.fields.file) return null;

  const {
    fields: {
      file: { url },
      title
    }
  } = image;

  return <img src={url} alt={title} {...rest} />;
};

Image.propTypes = {
  image: PropTypes.shape({
    fields: PropTypes.shape({
      file: PropTypes.shape({
        url: PropTypes.string
      }),
      title: PropTypes.string
    })
  })
};

Image.defaultProps = {
  image: null
};

export default Image;
